import type { ComponentType } from "react";

import { BillsAndDiscountsIcon } from "@jti/brand-icons/bills-and-discounts";
import { ChatIcon } from "@jti/brand-icons/chat";
import { DiamondIcon } from "@jti/brand-icons/diamond";
import { FireIcon } from "@jti/brand-icons/fire";
import { GiftIcon } from "@jti/brand-icons/gift";
import { LivechatIcon } from "@jti/brand-icons/livechat";
import { PackageIcon } from "@jti/brand-icons/package";
import { PackageArrowIcon } from "@jti/brand-icons/package-arrow";
import { PackageCheckIcon } from "@jti/brand-icons/package-check";
import { PackageTimeIcon } from "@jti/brand-icons/package-time";
import { ProfileCustomerServiceIcon } from "@jti/brand-icons/profile-customer-service";
import { StarShinningIcon } from "@jti/brand-icons/star-shinning";

import { LoyaltyBenefitIconName } from "./constants";

const iconComponents: Record<LoyaltyBenefitIconName, ComponentType> = {
  [LoyaltyBenefitIconName.ShippingPackageCheck]: PackageCheckIcon,
  [LoyaltyBenefitIconName.ShippingPackageTime]: PackageTimeIcon,
  [LoyaltyBenefitIconName.ShippingPackageArrow]: PackageArrowIcon,
  [LoyaltyBenefitIconName.ShippingPackage]: PackageIcon,
  [LoyaltyBenefitIconName.ShippingTime]: PackageTimeIcon,
  [LoyaltyBenefitIconName.CommunicationCustomService]: ProfileCustomerServiceIcon,
  [LoyaltyBenefitIconName.CommunicationChat]: ChatIcon,
  [LoyaltyBenefitIconName.CommunicationLiveChat]: LivechatIcon,
  [LoyaltyBenefitIconName.DiscountBillsAndDiscounts]: BillsAndDiscountsIcon,
  [LoyaltyBenefitIconName.DiscountGift]: GiftIcon,
  [LoyaltyBenefitIconName.SpecialsDiamond]: DiamondIcon,
  [LoyaltyBenefitIconName.SpecialsFire]: FireIcon,
  [LoyaltyBenefitIconName.SpecialsStarShinning]: StarShinningIcon,
};

export const LoyaltyBenefitIcon = ({ name }: { name: LoyaltyBenefitIconName | (string & {}) }) => {
  const Icon = iconComponents[name as LoyaltyBenefitIconName];

  return Icon ? <Icon /> : null;
};
